import { useCluster } from '@cast/shared-cluster-context-data-access';
import { useWorkloadsAccessContextQuery } from 'hooks/queries/workload-optimization';

import { isAccessContextOwner } from './makeIsNamespaceWritable';

/**
 * Returns true if the current cluster access context indicates the user is an
 * owner. Reads the access-context query (cached per clusterId) so multiple
 * consumers share a single fetch.
 */
export const useIsAccessContextOwner = (): boolean => {
  const { cluster } = useCluster();
  const { data: accessContext } = useWorkloadsAccessContextQuery({
    clusterId: cluster.id,
  });
  return isAccessContextOwner(accessContext);
};
